module.exports = ":host .invoices-section {\n  border-bottom: 1px solid #dddddd; }\n  :host .invoices-section .edit-payments-table td:first-child {\n    padding-left: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-update/invoice-update.scss
// module id = ./web/modern/components/invoices/invoice-update/invoice-update.scss
// module chunks = 0